module.exports = __webpack_public_path__ + "img/icon-archive-company.0af5ee81.svg";